import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NewsFeedItemHeaderBase } from '../news-feed-item-header-base';

@Component({
    selector: 'fi-news-feed-item-header-document',
    templateUrl: './news-feed-item-header-document.component.html',
    styleUrls: ['./news-feed-item-header-document.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NewsFeedItemHeaderDocumentComponent extends NewsFeedItemHeaderBase {}
